import React, { useState, useEffect } from 'react'

const WebDashboard = ({setLoading}) => {
  const [showAdd, setShowAdd] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [banner, setBanner] = useState()
const [formData, setFormData] = useState({
  tagline: '',
  description: '',
  image: null,
})
  const [selectedBanner, setSelectedBanner] = useState('');
  const [showDelete, setShowDelete] = useState(false);


const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setFormData({ ...formData, image: file });
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = new FormData();
  payload.append('tagline', formData.tagline);
  payload.append('description', formData.description);
  payload.append('image', formData.image);

  setLoading(true);

  try {
    const response = await fetch('https://api.kcian.in/add-banner', {
      method: 'POST',
      body: payload,
    });

    if (response.ok) {
        setLoading(false);
      setShowAdd(false);
      // fetchNotice();
      setFormData({ tagline: '', description: '', image: null });
      fetchBanner();
        setResponseMsg('Banner Added to Website!');
      setTimeout(() => setResponseMsg(''), 2000);
    } else {
        setLoading(false);      
        setResponseMsg('Something went wrong. Try again later.');
      setTimeout(() => setResponseMsg(''), 2000);
    }
  } catch (error) {
    console.error("Error submitting banner:", error);
        setLoading(false);
  }
};


          useEffect(() => {
              fetchBanner();
          }, []);


              const fetchBanner = async () => {
                  setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-banner');
      
                      if (response.ok) {
                          const data = await response.json();
//  data.sort((a, b) => new Date(b.date) - new Date(a.date));
 setBanner(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch banner');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
              };


                  const handleShowDel = (ach) => {
    setSelectedBanner(ach);
    setShowDelete(true);
  }


                const handleDelete = async (bannerId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-banner/${bannerId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setBanner((prevProducts) => prevProducts.filter((item) => item.id !== bannerId));
        setShowDelete(false);
        setResponseMsg('Banner deleted successfully!');
        setTimeout(() => {
          setResponseMsg('');
          window.location.reload();
        }, 2000);
      } else {
      setResponseMsg('Something Went Wrong. Please try again.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  return (
    <>
            <section className='my-5'>
        <div className='container'>
          <p className='page-heading'>Web Dashboard</p>
          <hr />

          <div className='text-end'>
            <button className='notice-btn' onClick={() => setShowAdd(true)}>
              <i className="fa-solid fa-pen-to-square"></i> New Banner
            </button>
          </div>

                    {responseMsg && (
            <div className='alert alert-success fw-semibold border-0  mt-2'>{responseMsg}</div>
          )}

{showAdd && (
  <>
            <div className='notice-card my-3'>
              <p className='fw-bold'>Add New Banner</p>


        <form onSubmit={handleSubmit}>

          <div className='mb-3'>
            <label className='login-label'>Banner Heading*</label>
            <input
              type='text'
              name='tagline'
              value={formData.tagline}
              onChange={handleChange}
              className='login-control'
              required
            />
          </div>

          <div className='mb-3'>
            <label className='login-label'>Description*</label>
            <textarea
              name='description'
              value={formData.description}
              onChange={handleChange}
              rows='4'
              className='login-control'
              required
            ></textarea>
          </div>

          <div className='mb-3'>
            <label className='login-label'>Upload Image for Background*</label>
            <input
              type='file'
              accept='image/*'
              onChange={handleImageChange}
              className='login-control'
              required
            />
          </div>


          {formData.image && (
            <div className='mb-3'>
              {/* <label className='login-label'>Image Preview:</label><br /> */}
              <img
                src={URL.createObjectURL(formData.image)}
                alt='Preview'
                className='img-fluid rounded border'
                style={{ maxHeight: '160px' }}
              />
            </div>
          )}

                  <button type='submit' className='notice-btn2 me-2'>
                    Submit
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowAdd(false)}>
                    Cancel
                  </button>

          {/* <div className='d-flex justify-content-between mt-4'>
            <button type='submit' className='btn btn-success'>Submit</button>
            <button type='button' className='btn btn-secondary' onClick={() => setShowAch(false)}>Cancel</button>
          </div> */}

        </form>

      </div>
  </>
)}


      {/* slider section */}
{banner && banner.length > 0 && (
  <div id="carouselExampleControls" className="carousel slide mt-3" data-bs-ride="carousel">
    <div className="carousel-inner">
      {banner.map((item, index) => (
        <div key={item.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
          <img src={`https://api.kcian.in/uploads/${item.image}`} className="slider-img w-100" alt={item.tagline} />
          <div className='carousel-content'>
            <div className='carousel-inner2 animate__animated animate__fadeInUp'>
              <hr className='slider-hr' />
              <p className='carousel-heading'>{item.tagline}</p>
              <p>{item.description}</p>
              <button className='notice-btn mt-3' onClick={() => handleShowDel(item)}>Remove Banner</button>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Carousel Controls */}
    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Previous</span>
    </button>
    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
      <span className="carousel-control-next-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Next</span>
    </button>
  </div>
)}


</div>
</section>


      {showDelete && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Delete Banner '{selectedBanner.tagline}'?</p>

                  <button type='submit' className='notice-btn2 me-2' onClick={() => handleDelete(selectedBanner.id)}>
                    Yes
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowDelete(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}
    </>
  )
}

export default WebDashboard
